// A simpler version inspired by $.numberFormat
export const numberFormat = (
  number,
  decimals,
  decimalSeparator,
  thousandsSeparator
) => {
  number = number.toFixed(decimals)
  let nstr = number.toString()
  nstr += ''
  let x = nstr.split('.')
  let x1 = x[0]
  let x2 = x.length > 1 ? decimalSeparator + x[1] : ''
  let rgx = /(\d+)(\d{3})/
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + thousandsSeparator + '$2')
  }
  return x1 + x2
}

export const formatPriceWithLocalizedCurrency = (price, locale, currency) => {
  return Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
  })
    .format(price)
    .replace(',', '.')
}

const _isNumerical = (object) => {
  object = object - 0
  return object
}

export const camelize = (string) => {
  if (_isNumerical(string)) {
    return string
  }
  string = string.replace(/[\-_\s]+(.)?/g, function (match, character) {
    return character ? character.toUpperCase() : ''
  })
  // 1st char is always lowercase
  return string.substr(0, 1).toLowerCase() + string.substr(1)
}

export const isEmail = (email) => {
  const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i

  return expression.test(String(email).toLowerCase())
}

export const isPhoneNumber = (phone_number) => {
  const expression = /^\+?[0-9\-\(\)\. ]{8,}$/i

  return expression.test(String(phone_number).toLowerCase())
}

export const areObjectsEqual = (obj1, obj2) => {
  const obj1Keys = Object.keys(obj1)
  const obj2Keys = Object.keys(obj2)

  if (obj1Keys.length !== obj2Keys.length) {
    return false
  }

  for (let objKey of obj1Keys) {
    if (obj1[objKey] !== obj2[objKey]) {
      return false
    }
  }

  return true
}

/**
 * Converts hex string to array of [r, g, b] components
 *
 * @param {string} hex hex string of the color
 * @returns {array}
 */
export const hexToRgbArray = (hex) => {
  hex = hex.replace('#', '')
  const _r = hex.length == 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2)
  const _g = hex.length == 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4)
  const _b = hex.length == 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6)
  const r = parseInt(_r, 16)
  const g = parseInt(_g, 16)
  const b = parseInt(_b, 16)

  return [r, g, b]
}

/**
 * Converts a hex string to a CSS rgba color property string
 *
 * @param {string} hex hex string of color
 * @param {number} alpha the alpha component of a color (between 0 and 1)
 * @returns {string}
 */
export const hexToRgba = (hex, alpha) => {
  const [r, g, b] = hexToRgbArray(hex)
  const a = alpha == null ? 1 : alpha
  return `rgba(${r}, ${g}, ${b}, ${a})`
}
